export const unselected = '∞';
